<div class="whiteOverlay" [hidden]="!showOverlay()">
    <div class="loader-background">
        <div class="loader">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                <circle class="circle" cx="12" cy="12" r="10" stroke-width="3" stroke="#3A5487"></circle>
                <circle class="dot" cx="21.3" cy="16" r="1.48" fill="#3A5487"></circle>
            </svg>
        </div>
    </div>
</div>